import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import lokasiKerjaService from "../../../services/ref/lokasiKerjaService";
import Cookies from "js-cookie";

export const initialState = {
    loading_lokasi_kerja: false,
    data_lokasi_kerja: [],
    showMessage:false,
    message:'',
}


export const getDataLokasiKerja = createAsyncThunk('lokasi_kerja/data',async (data, { rejectWithValue }) => {
    try {
        const response = await lokasiKerjaService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const lokasiKerjaSlice = createSlice({
    name: 'lokasi_kerja',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_lokasi_kerja = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataLokasiKerja.fulfilled, (state, action) => {
                state.loading_lokasi_kerja = false
                state.data_lokasi_kerja = action.payload??[]
            })
            .addCase(getDataLokasiKerja.pending, (state) => {
                state.loading_lokasi_kerja = true
            })
            .addCase(getDataLokasiKerja.rejected, (state, action) => {
                state.loading_lokasi_kerja = false
                state.data_lokasi_kerja = action.payload
            })
    },
})

export const {
    showLoading,
} = lokasiKerjaSlice.actions

export default lokasiKerjaSlice.reducer
